import React from 'react';
import ReactDOM from 'react-dom';
import MainContainer from './container/MainContainer';
import * as serviceWorker from './utils/serviceWorker';
import { Provider } from "react-redux";
import store from "./store/store.js";

import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/fontawesome-pro-5.11.1/css/all.css'
import 'react-toastify/dist/ReactToastify.css';
import './components/Grid/table.css'
import './assets/general.css';

ReactDOM.render(
  <React.Fragment>
    <Provider store={store}>
      <MainContainer />
    </Provider>
  </React.Fragment>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
